/**
 * Charte du Confort — IntersectionObserver
 * Crossfade the sticky visual when a chapter crosses the viewport center.
 */
(function () {
  var DESKTOP_MQ = '(min-width: 900px)';
  var instances = new WeakMap();

  function toIndex(el) {
    var value = el && el.getAttribute('data-cdc-index');
    var index = parseInt(value, 10);
    return isNaN(index) ? -1 : index;
  }

  function setActive(state, index) {
    if (index < 0 || index === state.active) return;
    state.active = index;

    state.chapters.forEach(function (chapter, i) {
      var on = i === index;
      chapter.classList.toggle('is-active', on);
      if (on) {
        chapter.setAttribute('aria-current', 'true');
      } else {
        chapter.removeAttribute('aria-current');
      }
    });

    state.visuals.forEach(function (visual, i) {
      var on = i === index;
      visual.classList.toggle('is-active', on);
      visual.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
  }

  function teardown(state) {
    if (state.observer) {
      state.observer.disconnect();
      state.observer = null;
    }
  }

  function observe(state) {
    teardown(state);

    if (!state.desktop.matches) {
      state.active = -1;
      state.chapters.forEach(function (chapter) {
        chapter.classList.add('is-active');
        chapter.removeAttribute('aria-current');
      });
      state.visuals.forEach(function (visual) {
        visual.classList.add('is-active');
        visual.setAttribute('aria-hidden', 'false');
      });
      return;
    }

    var next = state.active >= 0 ? state.active : 0;
    state.active = -1;
    setActive(state, next);

    if (!('IntersectionObserver' in window)) return;

    state.observer = new IntersectionObserver(
      function (entries) {
        var chosen = null;
        var ratio = -1;

        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (entry.intersectionRatio >= ratio) {
            ratio = entry.intersectionRatio;
            chosen = entry.target;
          }
        });

        if (!chosen) return;
        setActive(state, toIndex(chosen));
      },
      {
        root: null,
        rootMargin: '-45% 0px -45% 0px',
        threshold: 0
      }
    );

    state.chapters.forEach(function (chapter) {
      state.observer.observe(chapter);
    });
  }

  function bindMq(state) {
    if (state.mqBound) return;
    state.mqBound = true;

    var onChange = function () {
      observe(state);
    };

    if (state.desktop.addEventListener) {
      state.desktop.addEventListener('change', onChange);
    } else if (state.desktop.addListener) {
      state.desktop.addListener(onChange);
    }
  }

  function init(root) {
    if (!root) return;

    var prev = instances.get(root);
    if (prev) teardown(prev);

    var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-cdc-chapter]'));
    var visuals = Array.prototype.slice.call(root.querySelectorAll('[data-cdc-visual]'));
    if (!chapters.length || !visuals.length) return;

    var state = {
      root: root,
      chapters: chapters,
      visuals: visuals,
      observer: null,
      desktop: window.matchMedia(DESKTOP_MQ),
      active: 0,
      mqBound: prev ? prev.mqBound : false
    };

    instances.set(root, state);
    bindMq(state);
    observe(state);
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = context.querySelectorAll
      ? context.querySelectorAll('[data-cdc-root]')
      : [];

    if (context.matches && context.matches('[data-cdc-root]')) {
      init(context);
    }

    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-cdc-root]');
    var state = root && instances.get(root);
    if (state) teardown(state);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var chapter = event.target.closest('[data-cdc-chapter]');
    if (!chapter) return;
    var root = chapter.closest('[data-cdc-root]');
    var state = root && instances.get(root);
    if (!state || !state.desktop.matches) return;
    setActive(state, toIndex(chapter));
  });
})();
